import { PaymentsInterfaceState, initialPaymentsState } from '../state/payments.state';
import { PaymentsActions, EPaymentsActions } from '../actions/payments.actions';

export function paymentsReducer(state: PaymentsInterfaceState = initialPaymentsState, action: PaymentsActions): PaymentsInterfaceState {
  switch (action.type) {
    case EPaymentsActions.GetPaymentsSuccess: {
      return { ...state, payments: action.payload };
    }

    default:
      return state;
  }
};
